// Footer.js

function Footer() {
  return (
    <footer>
      <p>Created by (Sousa) Kevin De Sousa At Juno College, 2022</p>
    </footer>
  );
}

export default Footer;
